import React from "react";
import PreviewComponents from "./components/preview_components";


function App() {
  return (
    <div>
      <PreviewComponents />
    </div>
  );
}

export default App;
